module.exports = __webpack_public_path__ + "img/画板 1 拷贝 33.b12c5ae7.jpg";